import { BehaviorSubject } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, startWith, switchMap } from 'rxjs/operators';

// Utils
import { isUUID } from 'src/app/platform/utils/functions';
import { ResponseData } from 'src/app/platform/models/utils';

// Models
import { AccountData, User } from 'src/app/modules/account/models/user';

// Service
import { UiService } from 'src/app/platform/services/ui.service';
import { UserService } from 'src/app/modules/account/user.service';
import { ProceduresService } from 'src/app/modules/procedures/procedures.service';
import { AccountsService } from '../../accounts.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-accounts-admin-select',
  templateUrl: './accounts-admin-select.component.html',
  styleUrls: ['./accounts-admin-select.component.scss']
})
export class AccountsAdminSelectComponent implements OnInit {
  public user = new User();

  public adminAccounts = new BehaviorSubject<string>('');
  public adminAccountsValue = 0;
  public adminAccountsLoading = false;
  public adminAccountsData: Array<AccountData> = [];
  public adminAccountsDataFiltered = this.adminAccounts.pipe(
    startWith(''),
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(value => this.adminAccountsDataGet(value))
  );

  constructor(
    private router: Router,
    private dialog: MatDialogRef<AccountsAdminSelectComponent>,
    private uiService: UiService,
    private userService: UserService,
    private accountsService: AccountsService,
    private proceduresService: ProceduresService,
  ) {
    this.userService.currentUser.subscribe((user) => {
      this.user = user;
    });
  }

  ngOnInit(): void {
   
  }

  onCancel(){
    this.dialog.close();
  }

  onAccountSelect(): void{
    if (this.adminAccountsValue > 0) {
      if (this.adminAccountsValue !== this.user.client) {
        this.uiService.showSpinner(true);

        this.accountsService.accountSet(this.adminAccountsValue).then((status: boolean) => {
          this.uiService.showSpinner(false);

          if (this.accountsService.isAccountSelected()) {
            this.router.navigate(['resumen']);

            this.proceduresService.proceduresUpdate(true);
            this.dialog.close();
          } else {
            this.uiService.showSnackBar('No es posible administrar la cuenta ' + this.adminAccountsValue + ' en este momento (AC002).');
          }
        }, (error) => {
          this.uiService.showSpinner(false);
          this.uiService.showSnackBar(error);
        });
      }
    } else {
      this.uiService.showSnackBar('No es posible administrar la cuenta ' + this.adminAccountsValue + ' en este momento (AC001).');
    }
  }

  adminAccountsChange(value: string) {
    this.adminAccounts.next(value);
  }

  adminAccountsDataDisplay(id: number){
    let response = '';

    if (this.adminAccountsData.length > 0) {
      if (this.adminAccountsData[0] instanceof AccountData) {
        response = this.adminAccountsData.find(item => item.number === id)?.name ?? 'error';
        this.adminAccountsValue = id;
      }
    }

    return response;
  }

  private adminAccountsDataGet(value: string): Promise<Array<AccountData>> {
    return new Promise((resolve, reject) => {
      // If the value of the field is not empty and if it is not a whole
      // uuid since when selecting a value the field is updated by the ID
      if (value !== '' && !isUUID(value)) {
        this.adminAccountsLoading = true;

        this.userService.accounts(value).then((response: ResponseData) => {
          this.adminAccountsLoading = false;
          this.adminAccountsData = response.result;

          resolve(this.adminAccountsData);
        }).catch(() => {
          this.adminAccounts.next('');
          this.adminAccountsLoading = false;

          resolve(this.adminAccountsData);
        });
      } else {
        resolve(this.adminAccountsData);
      }
    });
  }
}
